function setViewedProduct(currentProductObject) {
	if (localStorage.getItem('viewedProduct')) {
		const currentProductHandle = currentProductObject.product_handle;
		const limit = window.viewed_settings.limit;
		const newViewedArr = [];
		let viewedFlag = false;

		const viewedArr = JSON.parse(localStorage.getItem('viewedProduct'));

		for (let i = 0; i < viewedArr.length; i++) {
			if (viewedArr[i].product_handle == currentProductHandle) {
				viewedFlag = true;
				return;
			}
		}

		if (!viewedFlag) {
			viewedArr.unshift(currentProductObject);

			for (let i = 0; i < viewedArr.length; i++) {
				if (i < limit) {
					newViewedArr.push(viewedArr[i]);
				}
			}

			localStorage.setItem('viewedProduct', JSON.stringify(newViewedArr));
		}
	} else {
		const viewedArr = [];

		viewedArr.push(currentProductObject);
		localStorage.setItem('viewedProduct', JSON.stringify(viewedArr));
	}
}

setViewedProduct(window.current_product);

if (!customElements.get('tpt-viewed-product')) {
	customElements.define(
		'tpt-viewed-product',
		class TptViewedProduct extends HTMLElement {
			constructor() {
				super();

				const tabItems = this.querySelectorAll('.tpt-related-viewed__tabs-item');
				this.viewedWrapper = this.querySelector('[data-viewed-container]');

				const viewedArr = JSON.parse(localStorage.getItem('viewedProduct'));

				if (viewedArr.length) {
					viewedArr.forEach((item) => {
						const productUrl = window.Shopify.routes.root + 'products/' + item.product_handle + '?section_id=tpt-viewed-product-item';

						const productContainer = `<div class="swiper-slide tpt-viewed_product-item" data-product-handle="${productUrl}"></div>`;

						this.viewedWrapper.insertAdjacentHTML('beforeend', productContainer);
					});
				}
			}

			connectedCallback() {
				setTimeout(() => {
					const productElement = this.querySelectorAll('[data-product-handle]');

					productElement.forEach((product) => {
						const productUrl = product.getAttribute('data-product-handle');

						fetch(productUrl)
							.then((response) => response.text())
							.then((responseText) => {
								const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
								const dataHtml = responseHTML.querySelector('.shopify-section').innerHTML;

								product.innerHTML = dataHtml;
							})
							.finally(() => {});
					});
				}, 200);
			}
		}
	);
}
